import { render, staticRenderFns } from "./tipItem.vue?vue&type=template&id=012458d8&scoped=true"
import script from "./tipItem.vue?vue&type=script&lang=js"
export * from "./tipItem.vue?vue&type=script&lang=js"
import style0 from "./tipItem.vue?vue&type=style&index=0&id=012458d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012458d8",
  null
  
)

export default component.exports